export const API_CONTENT_LIST_REQUEST = 'API_CONTENT_LIST_REQUEST';
export const API_CONTENT_LIST_SUCCESS = 'API_CONTENT_LIST_SUCCESS';
export const API_CONTENT_LIST_FAILURE = 'API_CONTENT_LIST_FAILURE';

export const API_CONTENT_ITEM_REQUEST = 'API_CONTENT_ITEM_REQUEST';
export const API_CONTENT_ITEM_SUCCESS = 'API_CONTENT_ITEM_SUCCESS';
export const API_CONTENT_ITEM_FAILURE = 'API_CONTENT_ITEM_FAILURE';


export const API_TOOLS_LIST_REQUEST = 'API_TOOLS_LIST_REQUEST';
export const API_TOOLS_LIST_SUCCESS = 'API_TOOLS_LIST_SUCCESS';
export const API_TOOLS_LIST_FAILURE = 'API_TOOLS_LIST_FAILURE';


export const API_ASSESSMENTS_LIST_REQUEST = 'API_ASSESSMENTS_LIST_REQUEST';
export const API_ASSESSMENTS_LIST_SUCCESS = 'API_ASSESSMENTS_LIST_SUCCESS';
export const API_ASSESSMENTS_LIST_FAILURE = 'API_ASSESSMENTS_LIST_FAILURE';

export const API_WEBINAR_LIST_REQUEST = 'API_WEBINAR_LIST_REQUEST';
export const API_WEBINAR_LIST_SUCCESS = 'API_WEBINAR_LIST_SUCCESS';
export const API_WEBINAR_LIST_FAILURE = 'API_WEBINAR_LIST_FAILURE';

export const toolsListRequest = payload => ({
  type: API_TOOLS_LIST_REQUEST,
  payload,
});

export const toolsListSuccess = payload => ({
  type: API_TOOLS_LIST_SUCCESS,
  payload,
});

export const toolsListFailure = payload => ({
  type: API_TOOLS_LIST_FAILURE,
  payload,
});

export const assessmentsListRequest = payload => ({
  type: API_ASSESSMENTS_LIST_REQUEST,
  payload,
});

export const assessmentsListSuccess = payload => ({
  type: API_ASSESSMENTS_LIST_SUCCESS,
  payload,
});

export const assessmentsListFailure = payload => ({
  type: API_WEBINAR_LIST_FAILURE,
  payload,
});

export const webinarListRequest = payload => ({
  type: API_WEBINAR_LIST_REQUEST,
  payload,
});

export const webinarListSuccess = payload => ({
  type: API_WEBINAR_LIST_SUCCESS,
  payload,
});

export const webinarListFailure = payload => ({
  type: API_WEBINAR_LIST_FAILURE,
  payload,
});


export const contentListRequest = payload => ({
  type: API_CONTENT_LIST_REQUEST,
  payload,
});

export const contentListSuccess = payload => ({
  type: API_CONTENT_LIST_SUCCESS,
  payload,
});

export const contentListFailure = payload => ({
  type: API_CONTENT_LIST_FAILURE,
  payload,
});

export const contentItemRequest = payload => ({
  type: API_CONTENT_ITEM_REQUEST,
  payload,
});

export const contentItemSuccess = payload => ({
  type: API_CONTENT_ITEM_SUCCESS,
  payload,
});

export const contentItemFailure = payload => ({
  type: API_CONTENT_ITEM_FAILURE,
  payload,
});

const initialState = {
  selectedProgramId: null,
  isFetched: false,
  isFetchedAssessments: false,
  isFetchingAssessments:false,
  fetching: false,
  isFetchedItem: false,
  fetchingItem: false,
  error: null,
  content: [],
  assessments: [],
  tools: [],
  webinars: []
};

export function contentListReducer(state = initialState, action) {
  switch (action.type) {
    case API_CONTENT_LIST_REQUEST:
      
      return {
        ...state,
        fetching: true,
        selectedProgramId: action.payload,
      };
    case API_CONTENT_LIST_SUCCESS:
    
      return {
        ...state,
        isFetched: true,
        fetching: false,
        content: action.payload,
      };
    case API_CONTENT_LIST_FAILURE:
      
      return {
        ...state,
        fetching: false,
        isFetched: false,
        error: action.payload,
      };
      case API_CONTENT_ITEM_REQUEST:
        
        return {
          ...state,
          fetchingItem: true,
          selectedProgramId: action.payload,
        };
      case API_CONTENT_ITEM_SUCCESS:
        
        return {
          ...state,
          isFetchedItem: true,
          fetchingItem: false,
          assessments: state.assessments.map((item, index) => {
            
            if (item.contentId !== action.payload.contentId) {
              // This isn't the item we care about - keep it as-is
              
              return item
            }else{
              
            }
            return {
              ...item,
              ...action.payload
            }
          }),
          tools: state.tools.map((item, index) => {
            
            if (item.contentId !== action.payload.contentId) {
              // This isn't the item we care about - keep it as-is
              
              return item
            }else{
              
            }
            return {
              ...item,
              ...action.payload
            }
          }),
          content: state.content.map((item, index) => {
            if (item.contentId !== action.payload.contentId) {
              // This isn't the item we care about - keep it as-is
              
              return item
            }else{
              
            }
            return {
              ...item,
              ...action.payload
            }
          }),
          webinars: state.webinars.map((item, index) => {
            
            if (item.contentId !== action.payload.contentId) {
              // This isn't the item we care about - keep it as-is
              
              return item
            }else{
              
            }
            return {
              ...item,
              ...action.payload
            }
          }),
          
        };
      case API_CONTENT_ITEM_FAILURE:
        
        return {
          ...state,
          fetchingItem: false,
          isFetchedItem: false,
          error: action.payload,
        };
        case API_TOOLS_LIST_REQUEST:
      
          return {
            ...state,
            fetching: true,
            selectedProgramId: action.payload,
          };
        case API_TOOLS_LIST_SUCCESS:
        
          return {
            ...state,
            isFetched: true,
            fetching: false,
            tools: action.payload,
          };
        case API_TOOLS_LIST_FAILURE:
          
          return {
            ...state,
            fetching: false,
            isFetched: false,
            error: action.payload,
          };
          case API_WEBINAR_LIST_REQUEST:
      
            return {
              ...state,
              fetching: true,
              selectedProgramId: action.payload,
            };
          case API_WEBINAR_LIST_SUCCESS:
          
            return {
              ...state,
              isFetched: true,
              fetching: false,
              webinar: action.payload,
            };
          case API_WEBINAR_LIST_FAILURE:
            
            return {
              ...state,
              fetching: false,
              isFetched: false,
              error: action.payload,
            };
          case API_ASSESSMENTS_LIST_REQUEST:
          
            return {
              ...state,
              isFetchedAssessments: false,
              isFetchingAssessments: true,
              selectedProgramId: action.payload,
            };
          case API_ASSESSMENTS_LIST_SUCCESS:
        
            return {
              ...state,
              isFetchedAssessments: true,
              isFetchingAssessments: false,
              assessments: action.payload,
            };
          case API_ASSESSMENTS_LIST_FAILURE:
            
            return {
              ...state,
              isFetchingAssessments: false,
              isFetchedAssessments: false,
              error: action.payload,
            };
    default:
      return state;
  }
}
